import type { Config } from '@/config/types.ts'; // 预发环境配置

// 预发环境配置
const config: Partial<Config> = {
  mobileBaseUrl: 'https://mcar-rc.chemt.cn',
};

export default config;
